import persianNumberFormat from "../../../helper/PersianNumberFormat";

export function PieChart(series, labels) {

  return {
    type: "pie",
    height: 300,
    series: series,
    options: {
      labels: labels,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 100
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      tooltip: {
        theme: "dark",
        y: {
          formatter: function (val) {
            return persianNumberFormat(val, true)
          }
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (value, {seriesIndex, dataPointIndex, w}) {
          return persianNumberFormat(value.toFixed(2)) + " %"
        },
      },
    },
  }
}

export default PieChart;
